import React from 'react';
import { Plus, FolderPlus } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext'; // Updated import path
import type { Project } from '../types/core';
import ProjectCard from './ProjectCard'; 
import { isOverdue, isDeadlineApproaching } from '../utils'; // Assuming utils.ts is in the parent directory

interface ProjectListProps {
  projects: Project[];
  onViewProject: (project: Project) => void;
  onDeleteProject: (project: Project) => void;
  onShowCreateProject: () => void;
  setProjects: React.Dispatch<React.SetStateAction<Project[]>>;
}

const ProjectList: React.FC<ProjectListProps> = ({ projects, onViewProject, onDeleteProject, onShowCreateProject, setProjects }) => {
  const { currentUser } = useAuth();
  const { t } = useLanguage();

  // Removed: if (!currentUser) return null;

  const visibleProjects = projects.filter(p => p.status !== 'closed'); // Filter out closed projects

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">{t('general.projects')} ({visibleProjects.length})</h1>
        <div className="flex space-x-3">
          {currentUser && (
            <button onClick={onShowCreateProject} className="btn-primary flex items-center">
              <Plus className="w-4 h-4 mr-2" /> {t('project.create')}
            </button>
          )}
        </div>
      </div>
      {visibleProjects.length === 0 ? (
        <div className="text-center py-16 text-gray-500 bg-white rounded-lg shadow">
          <FolderPlus className="w-20 h-20 mx-auto text-gray-300" />
          <p className="mt-4 text-xl">{t('project.no.projects')}</p>
          <p className="text-sm mt-1">{t('project.create.first')}</p>
        </div>
      ) : (
        <div className="project-card-list-grid">
          {visibleProjects.map((p: Project) => (
            <ProjectCard 
              key={p.id} 
              project={p} 
              onView={onViewProject} 
              onDelete={onDeleteProject} 
              currentUser={currentUser} 
              t={t} 
              isOverdue={isOverdue} 
              isDeadlineApproaching={isDeadlineApproaching}
              setProjects={setProjects}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectList;
